import Entity, { IEntity } from '../abstract/Entity';
import { IBuildingLevel } from './BuildingLevelModel';

export interface IMultiRoomBuilding extends IEntity {
  levels: Array<IBuildingLevel>;
}

class BuildingModel extends Entity implements IMultiRoomBuilding {
  levels: Array<IBuildingLevel>;

  constructor(levels: Array<IBuildingLevel> = []) {
    super();
    this.levels = levels;
  }

  getLevels(): Array<IBuildingLevel> {
    return this.levels;
  }

  getLevelById(uuid: string): IBuildingLevel | undefined {
    return this.levels.find((level) => level.uuid === uuid);
  }

  setLevels(levels: Array<IBuildingLevel>): void {
    this.levels = levels;
  }

  setLevelById(level: IBuildingLevel, uuid: string): boolean {
    const relatedIndex = this.levels.findIndex((level) => level.uuid === uuid);
    if (relatedIndex === -1) return false;

    this.levels[relatedIndex] = level;
    return true;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      levels: this.levels.map((l) => l.toJSON?.() ?? l),
    };
  }
}

export default BuildingModel;
